export default {
  sign_in_title: "登录您的账户",
  sign_up_title: "创建新账户",
  email: "邮箱地址",
  email_required: "请输入您的邮箱地址",
  email_placeholder: "your{0}example.com",
  email_invalid: "请输入有效的邮箱地址",
  password: "密码",
  password_placeholder: "输入您的密码",
  password_required: "请输入您的密码",
  password_invalid: "密码必须至少8个字符，包含字母、数字和特殊字符",
  forgot_password: "忘记密码？",
  confirm_password_required: "请确认您的密码",
  confirm_password_placeholder: "确认密码",
  passwords_do_not_match: "您输入的两次密码不一致",
  or: "或者",
  no_account: "还没有账户？",
  have_account: "已有账户？",
  error: "登录失败。请检查您的邮箱和密码。",
  google_error: "Google登录失败",
  x_error: "X登录失败",
  linkedin_error: "LinkedIn登录失败",
  google_sign_in: "使用Google登录",
  google_sign_up: "使用Google注册",
  apple_sign_in: "使用Apple登录",
  apple_sign_up: "使用Apple注册",
  twitter_sign_in: "使用X登录",
  twitter_sign_up: "使用X注册",
  linkedin_sign_in: "使用LinkedIn登录",
  linkedin_sign_up: "使用LinkedIn注册",
  aria_card: "登录卡片",
  aria_email: "邮箱输入框",
  aria_password: "密码输入框",
  aria_submit: "提交按钮",
  aria_google: "使用Google登录按钮",
  aria_linkedin: "使用LinkedIn登录按钮",
  aria_switch_mode: "切换登录/注册模式",
  welcome: "欢迎使用TaxEcoBit",
  subtitle: "欧盟CBAM合规碳税计算平台",
  benefit1: "精确的碳税计算，误差小于10%",
  benefit2: "支持多种运输方式和自定义因子",
  benefit3: "API集成支持",
  benefit4: "生成符合欧盟CBAM要求的合规报告",
  user_friendly: "用户友好",
  secure_reliable: "安全可靠",
  cloud_sync: "云同步",
  invite_code: "邀请码",
  invite_code_placeholder: "请输入邀请码（可选）",
  invite_code_detected: "检测到邀请码",
  invited_by_user: "邀请人",
  sign_out: "退出登录",
  agreement_prefix: "注册TaxEcoBit即表示您同意我们的",
  terms: "服务条款",
  and: "和",
  privacy: "隐私政策",
  agreement_required: "请先同意隐私政策",
  complete_verification: "请先完成验证",
  loading_verification: "加载验证中...",
  verification_failed: "验证失败，请重试",
};
